import commonUtil from '../../../utils/commonUtil';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_REGISTRATION = 'USER_REGISTRATION';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_FAIL = 'USER_REGISTRATION_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL';

export function isLoginEventLoaded(globalState) {
  return globalState.user && globalState.user.loaded;
}

export function _handleUserLogin(userCredential) {
  const userData = userCredential;
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL],
    promise: client => client.post('/api/signIn', {
      data: (userData),
    }), // params not used, just shown as demonstration
  };
}

export function isRegistrationEventLoaded(globalState) {
  return globalState.user && globalState.user.loaded;
}

export function _handleUserRegistration(userRegistrationForm) {
  return {
    types: [USER_REGISTRATION, USER_REGISTRATION_SUCCESS, USER_REGISTRATION_FAIL],
    promise: client => client.post('/api/signUp', {
      data: userRegistrationForm,
    }), // params not used, just shown as demonstration
  };
}

export function handleUserLogout(userLogout) {
  const userData = userLogout;
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [[USER_LOGOUT, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAIL]],
    promise: client => client.post('api/profile/logout', {
      data: userData,
    }),
  };
}
